export default {"src":"/_next/static/media/twitter.0f702181.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};